import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerDepotFacade } from './customer-depot.facade';
import { DepotOverview } from '@models/resources/depot.model';
import { DEMO_DEPOT_OVERVIEW } from '@data/fixtures/depot.fixtures';
import { dummyResponse } from '@data/dummy-response.util';

@Injectable()
export class DummyCustomerDepotFacade implements CustomerDepotFacade {
  getOverview(): Observable<DepotOverview> {
    return dummyResponse('customer.depot', DEMO_DEPOT_OVERVIEW);
  }
}
